import {BaseRouteMetaDataModel} from "../../../infrastructure/models/route/base-route.meta-data.model";

export class CompetitionRouteMetaDataModel extends BaseRouteMetaDataModel {
  get pageTitle() {
    return null
  }

  get description() {
    return null
  }
}